import React from 'react';
import { Menu } from 'antd';
import Logo from '../../images/logos/trackerapps.png'
import { translate } from 'react-i18next';
import { Link } from "react-router-dom";
import { compose } from 'redux';
require('../../styles/sidenav.css');

class SideMenuAdmin extends React.Component {

  render() {
    const { t } = this.props;
    return (
      <Menu
        defaultSelectedKeys="1"
        mode="inline"
        style={styles.menu}
      >
        <div style={styles.head}>
          <img src={Logo} style={styles.logo} alt="Skilltracker logo" />
          <div style={styles.title}>
            <p style={{marginTop: '20px', marginBottom: '25px'}}>{t('admindashboard')}</p>
            <p>{t('Dashboard')}</p>
          </div>
        </div>
        <Menu.Item key="1">
          <Link to="/student"><span>{t('Students')}</span></Link>
        </Menu.Item>
        <Menu.Item key="2">
          <Link to="/teacher"><span>{t('Teachers')}</span></Link>
        </Menu.Item>
        <Menu.Item key="3">
          <Link to="/subject"><span>{t('Subjects')}</span></Link>
        </Menu.Item>
        <Menu.Item key="4">
          <Link to="/class"><span>{t('Classes')}</span></Link>
        </Menu.Item>

      </Menu>
  )
  }
}

const enhancer = compose(
  translate('lang'),
)
export default enhancer(SideMenuAdmin);

const styles = {

  menu: {
    width: '230px',
    minHeight: '100vh',
    height: '100%',
    boxShadow: '1px -25px 10px 0 #D9E4EC',
    position: 'fixed'
  },

  logo: {
    width: '62px',
    height: 'auto',
    marginLeft: '28px'
  },

  head: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
    marginBottom: '10px'
  },

  title: {
    color: '#8CA0B3',
    fontSize: '17px',
    marginLeft: '10px',
    fontWeight: '600'
  }
}



// WEBPACK FOOTER //
// ./src/components/SideMenuAdmin/index.jsx